import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import ToolCard from '../components/ToolCard'
import { CATEGORIES, POPULAR_TOOLS } from '../data/tools'

/**
 * Vercel's SPA rewrite serves 200 for unknown paths, so a real 404 status isn't
 * available without breaking client routing. `noindex, follow` is the correct
 * mitigation: keeps these out of the index, still passes link equity onward.
 */
function NotFound() {
  return (
    <>
      <SEO
        title="Page not found — WebToolz365"
        description="That page doesn't exist. Browse the tool categories or jump to a popular tool."
        canonicalUrl="/404"
        noindex
      />

      <div className="container" style={{ paddingTop: 48, paddingBottom: 48 }}>
        <h1>Page not found</h1>
        <p style={{ color: 'var(--text-secondary)', maxWidth: 620, marginTop: 12 }}>
          The page you were looking for doesn&apos;t exist or has moved. Pick a category below,
          or try one of the most-used tools.
        </p>

        <nav
          aria-label="Category hubs"
          style={{ display: 'flex', flexWrap: 'wrap', gap: 12, margin: '28px 0 40px' }}
        >
          {CATEGORIES.map((c) => (
            <Link key={c.id} to={`/${c.route}`} className="btn btn-secondary">
              {c.navTitle}
            </Link>
          ))}
        </nav>

        <h2 className="section-title">Popular tools</h2>
        <div className="tools-grid">
          {POPULAR_TOOLS.map((tool) => (
            <ToolCard key={tool.slug} {...tool} />
          ))}
        </div>
      </div>
    </>
  )
}

export default NotFound
